import type { HeroSlide } from "@/types"

export const heroSlides: HeroSlide[] = [
  {
    id: "1",
    src: "https://images.unsplash.com/photo-1776351754040-b2b2621028b0?auto=format&fit=crop&w=1920&q=80",
    alt: "Rows of green crops under a dramatic cloudy sky",
  },
  {
    id: "2",
    src: "https://images.unsplash.com/photo-1761959258217-6e2527d19a5d?auto=format&fit=crop&w=1920&q=80",
    alt: "Old wooden barn in a rural landscape",
  },
  {
    id: "3",
    src: "https://images.unsplash.com/photo-1761637822973-b2b4e47250d7?auto=format&fit=crop&w=1920&q=80",
    alt: "Plowed agricultural field with distant trees",
  },
  {
    id: "4",
    src: "https://images.unsplash.com/photo-1753597534706-4d9a171f1ae3?auto=format&fit=crop&w=1920&q=80",
    alt: "Wind turbines standing on a foggy dark hill",
  },
]
